import { BaseAsyncValue } from '../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getOneClickPreloadedOrder } from '../../selectors/one-click-profiles.selector';

export namespace OneClickEditProvider {
  export class VisibleEdit extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.select(getOneClickPreloadedOrder).pipe(map(editView => !!editView));
    }
  }

  export class VisibleCreate extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.select(getOneClickPreloadedOrder).pipe(map(editView => !editView));
    }
  }
}
